import { useEffect, useState } from "react";
import config  from "../config";

import sendData from "../common/sendData";
import { useKeycloak } from "@react-keycloak/web";

const ApiURL = `${config.app.apiBaseUrl}chatbots/v1/Chatmessages/UserQuestion`;

function usePostChatmessagesUserQuestion(triggered, selectedChat, userId, userQuestion, caoOption) {
  const [statusCode, setStatusCode] = useState();
  const {keycloak} = useKeycloak();

  useEffect(() => {
    async function init() {
      if (!triggered && (selectedChat >= 0 || selectedChat === 'new')) return;
      let bearerToken = keycloak.token;

      let userQuestionData = {
          "userInput": userQuestion,
          "chatId": selectedChat,
          "userId": userId,
          "caoOption": caoOption
      }

      let response = await sendData(bearerToken, ApiURL, "POST", userQuestionData, false);
      setStatusCode(response);
    }
    init();
  }, [triggered])

  return statusCode;
}

export default usePostChatmessagesUserQuestion;
